/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Select_Folders_DescriptionInputs */



/**
* | output |
* | --- |
* | "Choose specific folders to sync. Leave empty to sync all." |
*
* @param {Spaces_Select_Folders_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_select_folders_description = /** @type {((inputs?: Spaces_Select_Folders_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Select_Folders_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Wähle bestimmte Ordner zum Synchronisieren. Leer lassen um alles zu synchronisieren.")
	return /** @type {LocalizedString} */ ("Choose specific folders to sync. Leave empty to sync all.")
});